import * as React from 'react'
import Form from '../Form'
import { FormSection as FormSectionClass } from './model'
import './style.scss'

type FormSectionRefs = {
  header: HTMLElement | null,
  body: HTMLElement | null,
}

const FormSection = React.forwardRef((props: FormSectionClass, ref: React.Ref<FormSectionRefs>) => {
  const {
    header,
    ...formProps
  } = props

  const formHeaderRef = React.useRef(null)
  const formBodyRef = React.useRef(null)
  React.useImperativeHandle(ref, () => ({
    get header() { return formHeaderRef.current },
    get body() { return formBodyRef.current }
  }))

  return (
    <section className="FormSection GlobSectPadSpacing">
      <div className="SpacingAdjust pt-mobile-l lg:pt-l"></div>
      <div ref={formHeaderRef} className="FontL col-span-6">
        {header}
      </div>
      <div ref={formBodyRef} className='mt-mobile-s lg:mt-s'>
        <Form {...formProps} />
      </div>
    </section>
  )
})
FormSection.displayName = 'FormSection'

export default FormSection
